<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <Breadcrumbs main="products" title="Products List" />
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card p3" v-for="item in listData" :key="item.host">
            <TableSites :id="item.id" :categories="item.categories" :currency="item.currency" :host="item.host">
            </TableSites>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import firebase from '@/utils/firestore-shim';
import TableSites from "./TableSites.vue";
import Cookies from 'js-cookie';
export default {
  components: { TableSites },
  data() {
    return {
      listData: []
    };
  },
  async mounted() {
    this.listData = await this.getStoresData();
  },
  methods: {
    async getStoresData() {
      let listData = [];
      var ProductRef = await firebase.firestore().collection("Sites")
        .where("host", "==", this.getStore())
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            listData.push(
              doc.data()
            );
          });
        });
      return listData;

    },
    getStore() {
      const host = Cookies.get('hostCookie');
      if (host) {
        return host;
      } else {
        this.$router.push('/dashboard/default');
      }
    },
  }
}
</script>

<style lang="scss" scoped>
table.text-center * {
  text-align: center;
}
</style>